import DataService from "../../../services/client/classes/dataService";

class OnboardingService extends DataService {
    constructor() {
        super('/onboarding/');
    }

    step(stepNumber: number, data: object): JQuery.jqXHR<any> {
        return this.post('step/' + stepNumber, data);
    }

    memberProfile(): JQuery.jqXHR<any> {
        return this.get('memberProfileData');
    }

    setOnboardingState(onboardingState: boolean): JQuery.jqXHR<any> {
        return this.post('setOnboardingState/'+ onboardingState);
    }
}

export default new OnboardingService();


// WEBPACK FOOTER //
// ./static-content/public/javascripts/services/onboarding-service.ts